var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"invited-badge"},[_c('span',{staticClass:"invited-text"},[_vm._v(" Invited by "+_vm._s(_vm.invitedBy.toUpperCase())+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }